
import * as gs from "@ivanlog/gs";
import {CmpBtnInfo} from "./CmpBtnInfo";
import {CmpHeader} from "./CmpHeader";
import {CmpHeroVX} from "./CmpHeroVX";
import {CmpInputAddress} from "./CmpInputAddress";
import {CmpInputIndex} from "./CmpInputIndex";
import {CmpInputTokenAmount} from "./CmpInputTokenAmount";
import {CmpModalDialog} from "./CmpModalDialog";
import {CmpRange} from "./CmpRange";
import {CmpSelectERC20} from "./CmpSelectERC20";
import {CmpWgtLPXNew} from "./CmpWgtLPXNew";
import {CmpWidgetChart} from "./CmpWidgetChart";
import {CmpWidgetLPXControl} from "./CmpWidgetLPXControl";
import {CmpWidgetLPXCtrl} from "./CmpWidgetLPXCtrl";
import {CmpWidgetLPXCtrlTabStartPool} from "./CmpWidgetLPXCtrlTabStartPool";
import {CmpWidgetLPXDetails} from "./CmpWidgetLPXDetails";
import {CmpWidgetLPXTable} from "./CmpWidgetLPXTable";
import {CmpWidgetShareXSaved} from "./CmpWidgetShareXSaved";
import {CmpWidgetShareXTable} from "./CmpWidgetShareXTable";
import {CmpWidgetShareXTokens} from "./CmpWidgetShareXTokens";
import {CmpWidgetVXApp} from "./CmpWidgetVXApp";
import {CmpWidgetVXSApp} from "./CmpWidgetVXSApp";
import {CmpWidgetVXStatus} from "./CmpWidgetVXStatus";

class CmpBtnInfoBaseControls {
	public readonly btn: gs.WrapperGS;
	public readonly lText: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.btn = ctrls.get('btn') as gs.WrapperGS;
		this.lText = ctrls.get('lText') as gs.WrapperGS;
	}
}
export class CmpBtnInfoBase extends gs.WrapperGS {
	public readonly ctrls: CmpBtnInfoBaseControls;
	constructor (){
		super("cmpBtnInfo");
		this.ctrls = new CmpBtnInfoBaseControls(this._controls);
	}
}
class CmpBtnWithTagControls {
	public readonly btn: gs.WrapperGS;
	public readonly lTag: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.btn = ctrls.get('btn') as gs.WrapperGS;
		this.lTag = ctrls.get('lTag') as gs.WrapperGS;
	}
}
export class CmpBtnWithTag extends gs.WrapperGS {
	public readonly ctrls: CmpBtnWithTagControls;
	constructor (){
		super("cmpBtnWithTag");
		this.ctrls = new CmpBtnWithTagControls(this._controls);
	}
}
class CmpFooterLPXControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpFooterLPX extends gs.WrapperGS {
	public readonly ctrls: CmpFooterLPXControls;
	constructor (){
		super("cmpFooterLPX");
		this.ctrls = new CmpFooterLPXControls(this._controls);
	}
}
class CmpFooterShareXControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpFooterShareX extends gs.WrapperGS {
	public readonly ctrls: CmpFooterShareXControls;
	constructor (){
		super("cmpFooterShareX");
		this.ctrls = new CmpFooterShareXControls(this._controls);
	}
}
class CmpFooterVXControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpFooterVX extends gs.WrapperGS {
	public readonly ctrls: CmpFooterVXControls;
	constructor (){
		super("cmpFooterVX");
		this.ctrls = new CmpFooterVXControls(this._controls);
	}
}
class CmpFormItemAddressPathControls {
	public readonly btnInfo: CmpBtnInfo;
	public readonly lLabel: gs.WrapperGS;
	public readonly btnAdd: gs.WrapperGS;
	public readonly btnRemove: gs.WrapperGS;
	public readonly iValue: gs.InputGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.btnInfo = ctrls.get('btnInfo') as CmpBtnInfo;
		this.lLabel = ctrls.get('lLabel') as gs.WrapperGS;
		this.btnAdd = ctrls.get('btnAdd') as gs.WrapperGS;
		this.btnRemove = ctrls.get('btnRemove') as gs.WrapperGS;
		this.iValue = ctrls.get('iValue') as gs.InputGS;
	}
}
export class CmpFormItemAddressPath extends gs.WrapperGS {
	public readonly ctrls: CmpFormItemAddressPathControls;
	constructor (){
		super("cmpFormItemAddressPath");
		this.ctrls = new CmpFormItemAddressPathControls(this._controls);
	}
}
class CmpHeaderBaseControls {
	public readonly tagPLS: gs.WrapperGS;
	public readonly tagWrongChain: gs.WrapperGS;
	public readonly btnConnect: gs.WrapperGS;
	public readonly btnMenu: gs.WrapperGS;
	public readonly blockMobileNav: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.tagPLS = ctrls.get('tagPLS') as gs.WrapperGS;
		this.tagWrongChain = ctrls.get('tagWrongChain') as gs.WrapperGS;
		this.btnConnect = ctrls.get('btnConnect') as gs.WrapperGS;
		this.btnMenu = ctrls.get('btnMenu') as gs.WrapperGS;
		this.blockMobileNav = ctrls.get('blockMobileNav') as gs.WrapperGS;
	}
}
export class CmpHeaderBase extends gs.WrapperGS {
	public readonly ctrls: CmpHeaderBaseControls;
	constructor (){
		super("cmpHeader");
		this.ctrls = new CmpHeaderBaseControls(this._controls);
	}
}
class CmpHeroLPXControls {
	public readonly blockLoading: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockLoading = ctrls.get('blockLoading') as gs.WrapperGS;
	}
}
export class CmpHeroLPX extends gs.WrapperGS {
	public readonly ctrls: CmpHeroLPXControls;
	constructor (){
		super("cmpHeroLPX");
		this.ctrls = new CmpHeroLPXControls(this._controls);
	}
}
class CmpHeroShareXControls {
	public readonly blockLoading: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockLoading = ctrls.get('blockLoading') as gs.WrapperGS;
	}
}
export class CmpHeroShareX extends gs.WrapperGS {
	public readonly ctrls: CmpHeroShareXControls;
	constructor (){
		super("cmpHeroShareX");
		this.ctrls = new CmpHeroShareXControls(this._controls);
	}
}
class CmpHeroVXBaseControls {
	public readonly blockTags: gs.WrapperGS;
	public readonly lAPR: gs.WrapperGS;
	public readonly btnInfo: gs.WrapperGS;
	public readonly lBtnInfo: gs.WrapperGS;
	public readonly blockLoading: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockTags = ctrls.get('blockTags') as gs.WrapperGS;
		this.lAPR = ctrls.get('lAPR') as gs.WrapperGS;
		this.btnInfo = ctrls.get('btnInfo') as gs.WrapperGS;
		this.lBtnInfo = ctrls.get('lBtnInfo') as gs.WrapperGS;
		this.blockLoading = ctrls.get('blockLoading') as gs.WrapperGS;
	}
}
export class CmpHeroVXBase extends gs.WrapperGS {
	public readonly ctrls: CmpHeroVXBaseControls;
	constructor (){
		super("cmpHeroVX");
		this.ctrls = new CmpHeroVXBaseControls(this._controls);
	}
}
class CmpInfo3StepsControls {
	public readonly list: gs.WrapperGS;
	public readonly btnInfo1: CmpBtnInfo;
	public readonly lStep1: gs.WrapperGS;
	public readonly lStep1Info: gs.WrapperGS;
	public readonly btnInfo2: CmpBtnInfo;
	public readonly lStep2: gs.WrapperGS;
	public readonly lStep2Info: gs.WrapperGS;
	public readonly btnInfo3: CmpBtnInfo;
	public readonly lStep3: gs.WrapperGS;
	public readonly lStep3Info: gs.WrapperGS;
	public readonly lComment: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.list = ctrls.get('list') as gs.WrapperGS;
		this.btnInfo1 = ctrls.get('btnInfo1') as CmpBtnInfo;
		this.lStep1 = ctrls.get('lStep1') as gs.WrapperGS;
		this.lStep1Info = ctrls.get('lStep1Info') as gs.WrapperGS;
		this.btnInfo2 = ctrls.get('btnInfo2') as CmpBtnInfo;
		this.lStep2 = ctrls.get('lStep2') as gs.WrapperGS;
		this.lStep2Info = ctrls.get('lStep2Info') as gs.WrapperGS;
		this.btnInfo3 = ctrls.get('btnInfo3') as CmpBtnInfo;
		this.lStep3 = ctrls.get('lStep3') as gs.WrapperGS;
		this.lStep3Info = ctrls.get('lStep3Info') as gs.WrapperGS;
		this.lComment = ctrls.get('lComment') as gs.WrapperGS;
	}
}
export class CmpInfo3Steps extends gs.WrapperGS {
	public readonly ctrls: CmpInfo3StepsControls;
	constructor (){
		super("cmpInfo3Steps");
		this.ctrls = new CmpInfo3StepsControls(this._controls);
	}
}
class CmpInputAddressBaseControls {
	public readonly iValue: gs.InputGS;
	public readonly lSubText: gs.WrapperGS;
	public readonly blockInfo: gs.WrapperGS;
	public readonly imgIcon: gs.ImageGS;
	public readonly lAddressName: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.iValue = ctrls.get('iValue') as gs.InputGS;
		this.lSubText = ctrls.get('lSubText') as gs.WrapperGS;
		this.blockInfo = ctrls.get('blockInfo') as gs.WrapperGS;
		this.imgIcon = ctrls.get('imgIcon') as gs.ImageGS;
		this.lAddressName = ctrls.get('lAddressName') as gs.WrapperGS;
	}
}
export class CmpInputAddressBase extends gs.WrapperGS {
	public readonly ctrls: CmpInputAddressBaseControls;
	constructor (){
		super("cmpInputAddress");
		this.ctrls = new CmpInputAddressBaseControls(this._controls);
	}
}
class CmpInputIndexBaseControls {
	public readonly iValue: gs.InputGS;
	public readonly lSubText: gs.WrapperGS;
	public readonly lAddressName: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.iValue = ctrls.get('iValue') as gs.InputGS;
		this.lSubText = ctrls.get('lSubText') as gs.WrapperGS;
		this.lAddressName = ctrls.get('lAddressName') as gs.WrapperGS;
	}
}
export class CmpInputIndexBase extends gs.WrapperGS {
	public readonly ctrls: CmpInputIndexBaseControls;
	constructor (){
		super("cmpInputIndex");
		this.ctrls = new CmpInputIndexBaseControls(this._controls);
	}
}
class CmpInputTokenAmountBaseControls {
	public readonly iValue: gs.InputGS;
	public readonly lSubText: gs.WrapperGS;
	public readonly imgIcon: gs.ImageGS;
	public readonly lTokenName: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.iValue = ctrls.get('iValue') as gs.InputGS;
		this.lSubText = ctrls.get('lSubText') as gs.WrapperGS;
		this.imgIcon = ctrls.get('imgIcon') as gs.ImageGS;
		this.lTokenName = ctrls.get('lTokenName') as gs.WrapperGS;
	}
}
export class CmpInputTokenAmountBase extends gs.WrapperGS {
	public readonly ctrls: CmpInputTokenAmountBaseControls;
	constructor (){
		super("cmpInputTokenAmount");
		this.ctrls = new CmpInputTokenAmountBaseControls(this._controls);
	}
}
class CmpInputTokensControls {
	public readonly cmpInputTokenAmount0: CmpInputTokenAmount;
	public readonly blockImgPlus: gs.WrapperGS;
	public readonly blockImgMinus: gs.WrapperGS;
	public readonly cmpInputTokenAmount1: CmpInputTokenAmount;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpInputTokenAmount0 = ctrls.get('cmpInputTokenAmount0') as CmpInputTokenAmount;
		this.blockImgPlus = ctrls.get('blockImgPlus') as gs.WrapperGS;
		this.blockImgMinus = ctrls.get('blockImgMinus') as gs.WrapperGS;
		this.cmpInputTokenAmount1 = ctrls.get('cmpInputTokenAmount1') as CmpInputTokenAmount;
	}
}
export class CmpInputTokens extends gs.WrapperGS {
	public readonly ctrls: CmpInputTokensControls;
	constructor (){
		super("cmpInputTokens");
		this.ctrls = new CmpInputTokensControls(this._controls);
	}
}
class CmpInputTokensSwapControls {
	public readonly cmpInputTokenAmount0: CmpInputTokenAmount;
	public readonly cmpInputTokenAmount1: CmpInputTokenAmount;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpInputTokenAmount0 = ctrls.get('cmpInputTokenAmount0') as CmpInputTokenAmount;
		this.cmpInputTokenAmount1 = ctrls.get('cmpInputTokenAmount1') as CmpInputTokenAmount;
	}
}
export class CmpInputTokensSwap extends gs.WrapperGS {
	public readonly ctrls: CmpInputTokensSwapControls;
	constructor (){
		super("cmpInputTokensSwap");
		this.ctrls = new CmpInputTokensSwapControls(this._controls);
	}
}
class CmpModalDialogBaseControls {
	public readonly background: gs.WrapperGS;
	public readonly container: gs.WrapperGS;
	public readonly btnClose: gs.WrapperGS;
	public readonly lTitle: gs.WrapperGS;
	public readonly lText: gs.WrapperGS;
	public readonly btnOk: gs.WrapperGS;
	public readonly btnNo: gs.WrapperGS;
	public readonly btnCancel: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.background = ctrls.get('background') as gs.WrapperGS;
		this.container = ctrls.get('container') as gs.WrapperGS;
		this.btnClose = ctrls.get('btnClose') as gs.WrapperGS;
		this.lTitle = ctrls.get('lTitle') as gs.WrapperGS;
		this.lText = ctrls.get('lText') as gs.WrapperGS;
		this.btnOk = ctrls.get('btnOk') as gs.WrapperGS;
		this.btnNo = ctrls.get('btnNo') as gs.WrapperGS;
		this.btnCancel = ctrls.get('btnCancel') as gs.WrapperGS;
	}
}
export class CmpModalDialogBase extends gs.WrapperGS {
	public readonly ctrls: CmpModalDialogBaseControls;
	constructor (){
		super("cmpModalDialog");
		this.ctrls = new CmpModalDialogBaseControls(this._controls);
	}
}
class CmpPriceRangeControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpPriceRange extends gs.WrapperGS {
	public readonly ctrls: CmpPriceRangeControls;
	constructor (){
		super("cmpPriceRange");
		this.ctrls = new CmpPriceRangeControls(this._controls);
	}
}
class CmpRangeBaseControls {
	public readonly range: gs.WrapperGS;
	public readonly background: gs.WrapperGS;
	public readonly cursor: gs.BoxItem;
	public readonly lValue: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.range = ctrls.get('range') as gs.WrapperGS;
		this.background = ctrls.get('background') as gs.WrapperGS;
		this.cursor = ctrls.get('cursor') as gs.BoxItem;
		this.lValue = ctrls.get('lValue') as gs.WrapperGS;
	}
}
export class CmpRangeBase extends gs.WrapperGS {
	public readonly ctrls: CmpRangeBaseControls;
	constructor (){
		super("cmpRange");
		this.ctrls = new CmpRangeBaseControls(this._controls);
	}
}
class CmpSearchControls {
	public readonly iSearch: gs.InputGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.iSearch = ctrls.get('iSearch') as gs.InputGS;
	}
}
export class CmpSearch extends gs.WrapperGS {
	public readonly ctrls: CmpSearchControls;
	constructor (){
		super("cmpSearch");
		this.ctrls = new CmpSearchControls(this._controls);
	}
}
class CmpSelectERC20BaseControls {
	public readonly cmpSearch: CmpSearch;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpSearch = ctrls.get('cmpSearch') as CmpSearch;
	}
}
export class CmpSelectERC20Base extends gs.WrapperGS {
	public readonly ctrls: CmpSelectERC20BaseControls;
	constructor (){
		super("cmpSelectERC20");
		this.ctrls = new CmpSelectERC20BaseControls(this._controls);
	}
}
class CmpTableHeaderERC20Controls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpTableHeaderERC20 extends gs.WrapperGS {
	public readonly ctrls: CmpTableHeaderERC20Controls;
	constructor (){
		super("cmpTableHeaderERC20");
		this.ctrls = new CmpTableHeaderERC20Controls(this._controls);
	}
}
class CmpTableHeaderLPXControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpTableHeaderLPX extends gs.WrapperGS {
	public readonly ctrls: CmpTableHeaderLPXControls;
	constructor (){
		super("cmpTableHeaderLPX");
		this.ctrls = new CmpTableHeaderLPXControls(this._controls);
	}
}
class CmpTableHeaderShareXControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpTableHeaderShareX extends gs.WrapperGS {
	public readonly ctrls: CmpTableHeaderShareXControls;
	constructor (){
		super("cmpTableHeaderShareX");
		this.ctrls = new CmpTableHeaderShareXControls(this._controls);
	}
}
class CmpTableItemERC20Controls {
	public readonly lSymbol: gs.WrapperGS;
	public readonly lAdrs: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.lSymbol = ctrls.get('lSymbol') as gs.WrapperGS;
		this.lAdrs = ctrls.get('lAdrs') as gs.WrapperGS;
	}
}
export class CmpTableItemERC20 extends gs.WrapperGS {
	public readonly ctrls: CmpTableItemERC20Controls;
	constructor (){
		super("cmpTableItemERC20");
		this.ctrls = new CmpTableItemERC20Controls(this._controls);
	}
}
class CmpTableItemLPXControls {
	public readonly lSymbols: gs.WrapperGS;
	public readonly lReserveFund: gs.WrapperGS;
	public readonly lReserveAnchor: gs.WrapperGS;
	public readonly lAPR: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.lSymbols = ctrls.get('lSymbols') as gs.WrapperGS;
		this.lReserveFund = ctrls.get('lReserveFund') as gs.WrapperGS;
		this.lReserveAnchor = ctrls.get('lReserveAnchor') as gs.WrapperGS;
		this.lAPR = ctrls.get('lAPR') as gs.WrapperGS;
	}
}
export class CmpTableItemLPX extends gs.WrapperGS {
	public readonly ctrls: CmpTableItemLPXControls;
	constructor (){
		super("cmpTableItemLPX");
		this.ctrls = new CmpTableItemLPXControls(this._controls);
	}
}
class CmpTableItemShareXControls {
	public readonly lSymbol: gs.WrapperGS;
	public readonly lToCalc: gs.WrapperGS;
	public readonly lToClaim: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.lSymbol = ctrls.get('lSymbol') as gs.WrapperGS;
		this.lToCalc = ctrls.get('lToCalc') as gs.WrapperGS;
		this.lToClaim = ctrls.get('lToClaim') as gs.WrapperGS;
	}
}
export class CmpTableItemShareX extends gs.WrapperGS {
	public readonly ctrls: CmpTableItemShareXControls;
	constructor (){
		super("cmpTableItemShareX");
		this.ctrls = new CmpTableItemShareXControls(this._controls);
	}
}
class CmpWgtLPXNewBaseControls {
	public readonly tglSelectFund: gs.BoxItem;
	public readonly tglSelectAnchor: gs.BoxItem;
	public readonly tglConfig: gs.BoxItem;
	public readonly blockSelectFund: gs.WrapperGS;
	public readonly cmpSelectFund: CmpSelectERC20;
	public readonly btnCancel: gs.WrapperGS;
	public readonly btnSubmitFund: gs.WrapperGS;
	public readonly blockSelectAnchor: gs.WrapperGS;
	public readonly cmpSelectAnchor: CmpSelectERC20;
	public readonly btnToFund: gs.WrapperGS;
	public readonly btnSubmitAnchor: gs.WrapperGS;
	public readonly blockConfig: gs.WrapperGS;
	public readonly cmpChart: CmpWidgetChart;
	public readonly cmpNtz: CmpInputIndex;
	public readonly cmpProfit: CmpRange;
	public readonly lInfo: gs.WrapperGS;
	public readonly btnToAnchor: gs.WrapperGS;
	public readonly btnCreate: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.tglSelectFund = ctrls.get('tglSelectFund') as gs.BoxItem;
		this.tglSelectAnchor = ctrls.get('tglSelectAnchor') as gs.BoxItem;
		this.tglConfig = ctrls.get('tglConfig') as gs.BoxItem;
		this.blockSelectFund = ctrls.get('blockSelectFund') as gs.WrapperGS;
		this.cmpSelectFund = ctrls.get('cmpSelectFund') as CmpSelectERC20;
		this.btnCancel = ctrls.get('btnCancel') as gs.WrapperGS;
		this.btnSubmitFund = ctrls.get('btnSubmitFund') as gs.WrapperGS;
		this.blockSelectAnchor = ctrls.get('blockSelectAnchor') as gs.WrapperGS;
		this.cmpSelectAnchor = ctrls.get('cmpSelectAnchor') as CmpSelectERC20;
		this.btnToFund = ctrls.get('btnToFund') as gs.WrapperGS;
		this.btnSubmitAnchor = ctrls.get('btnSubmitAnchor') as gs.WrapperGS;
		this.blockConfig = ctrls.get('blockConfig') as gs.WrapperGS;
		this.cmpChart = ctrls.get('cmpChart') as CmpWidgetChart;
		this.cmpNtz = ctrls.get('cmpNtz') as CmpInputIndex;
		this.cmpProfit = ctrls.get('cmpProfit') as CmpRange;
		this.lInfo = ctrls.get('lInfo') as gs.WrapperGS;
		this.btnToAnchor = ctrls.get('btnToAnchor') as gs.WrapperGS;
		this.btnCreate = ctrls.get('btnCreate') as gs.WrapperGS;
	}
}
export class CmpWgtLPXNewBase extends gs.WrapperGS {
	public readonly ctrls: CmpWgtLPXNewBaseControls;
	constructor (){
		super("cmpWgtLPXNew");
		this.ctrls = new CmpWgtLPXNewBaseControls(this._controls);
	}
}
class CmpWidgetChartBaseControls {
	public readonly lTitle: gs.WrapperGS;
	public readonly chart: gs.WrapperGS;
	public readonly btns: gs.WrapperGS;
	public readonly lText: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.lTitle = ctrls.get('lTitle') as gs.WrapperGS;
		this.chart = ctrls.get('chart') as gs.WrapperGS;
		this.btns = ctrls.get('btns') as gs.WrapperGS;
		this.lText = ctrls.get('lText') as gs.WrapperGS;
	}
}
export class CmpWidgetChartBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetChartBaseControls;
	constructor (){
		super("cmpWidgetChart");
		this.ctrls = new CmpWidgetChartBaseControls(this._controls);
	}
}
class CmpWidgetInfoLPXControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpWidgetInfoLPX extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetInfoLPXControls;
	constructor (){
		super("cmpWidgetInfoLPX");
		this.ctrls = new CmpWidgetInfoLPXControls(this._controls);
	}
}
class CmpWidgetInfoSVControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpWidgetInfoSV extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetInfoSVControls;
	constructor (){
		super("cmpWidgetInfoSV");
		this.ctrls = new CmpWidgetInfoSVControls(this._controls);
	}
}
class CmpWidgetInfoTokenTiersControls {
	constructor (ctrls: Map<string, gs.WrapperGS>){
	}
}
export class CmpWidgetInfoTokenTiers extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetInfoTokenTiersControls;
	constructor (){
		super("cmpWidgetInfoTokenTiers");
		this.ctrls = new CmpWidgetInfoTokenTiersControls(this._controls);
	}
}
class CmpWidgetInfoUDexControls {
	public readonly aMain: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.aMain = ctrls.get('aMain') as gs.WrapperGS;
	}
}
export class CmpWidgetInfoUDex extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetInfoUDexControls;
	constructor (){
		super("cmpWidgetInfoUDex");
		this.ctrls = new CmpWidgetInfoUDexControls(this._controls);
	}
}
class CmpWidgetInfoVXControls {
	public readonly aMain: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.aMain = ctrls.get('aMain') as gs.WrapperGS;
	}
}
export class CmpWidgetInfoVX extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetInfoVXControls;
	constructor (){
		super("cmpWidgetInfoVX");
		this.ctrls = new CmpWidgetInfoVXControls(this._controls);
	}
}
class CmpWidgetInfoVXSControls {
	public readonly aMain: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.aMain = ctrls.get('aMain') as gs.WrapperGS;
	}
}
export class CmpWidgetInfoVXS extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetInfoVXSControls;
	constructor (){
		super("cmpWidgetInfoVXS");
		this.ctrls = new CmpWidgetInfoVXSControls(this._controls);
	}
}
class CmpWidgetLPXControlBaseControls {
	public readonly blockStartLPX: gs.WrapperGS;
	public readonly tglStartLPX: gs.WrapperGS;
	public readonly formStartLPX: gs.FormGS;
	public readonly cmpStartMaxPrice: CmpInputTokenAmount;
	public readonly cmpStartPrice: CmpInputTokenAmount;
	public readonly cmpStartTokens: CmpInputTokens;
	public readonly btnStartLPX: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockStartLPX = ctrls.get('blockStartLPX') as gs.WrapperGS;
		this.tglStartLPX = ctrls.get('tglStartLPX') as gs.WrapperGS;
		this.formStartLPX = ctrls.get('formStartLPX') as gs.FormGS;
		this.cmpStartMaxPrice = ctrls.get('cmpStartMaxPrice') as CmpInputTokenAmount;
		this.cmpStartPrice = ctrls.get('cmpStartPrice') as CmpInputTokenAmount;
		this.cmpStartTokens = ctrls.get('cmpStartTokens') as CmpInputTokens;
		this.btnStartLPX = ctrls.get('btnStartLPX') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXControlBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXControlBaseControls;
	constructor (){
		super("cmpWidgetLPXControl");
		this.ctrls = new CmpWidgetLPXControlBaseControls(this._controls);
	}
}
class CmpWidgetLPXCtrlBaseControls {
	public readonly tglStartPool: gs.BoxItem;
	public readonly tglAddLiquidity: gs.BoxItem;
	public readonly tglRemoveLiquidity: gs.BoxItem;
	public readonly blockStartPool: CmpWidgetLPXCtrlTabStartPool;
	public readonly blockAddLiquidity: gs.WrapperGS;
	public readonly formAddLiquidity: gs.FormGS;
	public readonly cmpAddLiquidityTokens: CmpInputTokens;
	public readonly btnAddLiquidity: gs.WrapperGS;
	public readonly blockRemoveLiquidity: gs.WrapperGS;
	public readonly formRemoveLiquidity: gs.FormGS;
	public readonly rRemoveLiquidityPart: CmpRange;
	public readonly cmpRemoveLiquidityTokens: CmpInputTokens;
	public readonly btnRemoveLiquidity: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.tglStartPool = ctrls.get('tglStartPool') as gs.BoxItem;
		this.tglAddLiquidity = ctrls.get('tglAddLiquidity') as gs.BoxItem;
		this.tglRemoveLiquidity = ctrls.get('tglRemoveLiquidity') as gs.BoxItem;
		this.blockStartPool = ctrls.get('blockStartPool') as CmpWidgetLPXCtrlTabStartPool;
		this.blockAddLiquidity = ctrls.get('blockAddLiquidity') as gs.WrapperGS;
		this.formAddLiquidity = ctrls.get('formAddLiquidity') as gs.FormGS;
		this.cmpAddLiquidityTokens = ctrls.get('cmpAddLiquidityTokens') as CmpInputTokens;
		this.btnAddLiquidity = ctrls.get('btnAddLiquidity') as gs.WrapperGS;
		this.blockRemoveLiquidity = ctrls.get('blockRemoveLiquidity') as gs.WrapperGS;
		this.formRemoveLiquidity = ctrls.get('formRemoveLiquidity') as gs.FormGS;
		this.rRemoveLiquidityPart = ctrls.get('rRemoveLiquidityPart') as CmpRange;
		this.cmpRemoveLiquidityTokens = ctrls.get('cmpRemoveLiquidityTokens') as CmpInputTokens;
		this.btnRemoveLiquidity = ctrls.get('btnRemoveLiquidity') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXCtrlBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXCtrlBaseControls;
	constructor (){
		super("cmpWidgetLPXCtrl");
		this.ctrls = new CmpWidgetLPXCtrlBaseControls(this._controls);
	}
}
class CmpWidgetLPXCtrlTabStartPoolBaseControls {
	public readonly cmpChart: CmpWidgetChart;
	public readonly formStartLPX: gs.FormGS;
	public readonly cmpStartMaxPrice: CmpInputTokenAmount;
	public readonly cmpStartPrice: CmpInputTokenAmount;
	public readonly cmpStartTokens: CmpInputTokens;
	public readonly btnStartLPX: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpChart = ctrls.get('cmpChart') as CmpWidgetChart;
		this.formStartLPX = ctrls.get('formStartLPX') as gs.FormGS;
		this.cmpStartMaxPrice = ctrls.get('cmpStartMaxPrice') as CmpInputTokenAmount;
		this.cmpStartPrice = ctrls.get('cmpStartPrice') as CmpInputTokenAmount;
		this.cmpStartTokens = ctrls.get('cmpStartTokens') as CmpInputTokens;
		this.btnStartLPX = ctrls.get('btnStartLPX') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXCtrlTabStartPoolBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXCtrlTabStartPoolBaseControls;
	constructor (){
		super("cmpWidgetLPXCtrlTabStartPool");
		this.ctrls = new CmpWidgetLPXCtrlTabStartPoolBaseControls(this._controls);
	}
}
class CmpWidgetLPXDetailsBaseControls {
	public readonly imgFund: gs.ImageGS;
	public readonly lFundSymbol: gs.WrapperGS;
	public readonly imgAnchor: gs.ImageGS;
	public readonly lAnchorSymbol: gs.WrapperGS;
	public readonly lPoolId: gs.WrapperGS;
	public readonly lType: gs.WrapperGS;
	public readonly lMode: gs.WrapperGS;
	public readonly lAPR: gs.WrapperGS;
	public readonly lNTZ: gs.WrapperGS;
	public readonly lProfit: gs.WrapperGS;
	public readonly lReinvested: gs.WrapperGS;
	public readonly blockManagerReward: gs.WrapperGS;
	public readonly lManagerReward: gs.WrapperGS;
	public readonly lFee: gs.WrapperGS;
	public readonly lPriceEnd: gs.WrapperGS;
	public readonly lPriceSell: gs.WrapperGS;
	public readonly lPriceBuy: gs.WrapperGS;
	public readonly lPriceStart: gs.WrapperGS;
	public readonly lFundAdr: gs.WrapperGS;
	public readonly btnCopyAdrFund: gs.WrapperGS;
	public readonly lAnchorAdr: gs.WrapperGS;
	public readonly btnCopyAdrAnchor: gs.WrapperGS;
	public readonly lManagerAdr: gs.WrapperGS;
	public readonly btnCopyAdrManager: gs.WrapperGS;
	public readonly lPortfolio: gs.WrapperGS;
	public readonly lYield: gs.WrapperGS;
	public readonly btnClaimYield: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.imgFund = ctrls.get('imgFund') as gs.ImageGS;
		this.lFundSymbol = ctrls.get('lFundSymbol') as gs.WrapperGS;
		this.imgAnchor = ctrls.get('imgAnchor') as gs.ImageGS;
		this.lAnchorSymbol = ctrls.get('lAnchorSymbol') as gs.WrapperGS;
		this.lPoolId = ctrls.get('lPoolId') as gs.WrapperGS;
		this.lType = ctrls.get('lType') as gs.WrapperGS;
		this.lMode = ctrls.get('lMode') as gs.WrapperGS;
		this.lAPR = ctrls.get('lAPR') as gs.WrapperGS;
		this.lNTZ = ctrls.get('lNTZ') as gs.WrapperGS;
		this.lProfit = ctrls.get('lProfit') as gs.WrapperGS;
		this.lReinvested = ctrls.get('lReinvested') as gs.WrapperGS;
		this.blockManagerReward = ctrls.get('blockManagerReward') as gs.WrapperGS;
		this.lManagerReward = ctrls.get('lManagerReward') as gs.WrapperGS;
		this.lFee = ctrls.get('lFee') as gs.WrapperGS;
		this.lPriceEnd = ctrls.get('lPriceEnd') as gs.WrapperGS;
		this.lPriceSell = ctrls.get('lPriceSell') as gs.WrapperGS;
		this.lPriceBuy = ctrls.get('lPriceBuy') as gs.WrapperGS;
		this.lPriceStart = ctrls.get('lPriceStart') as gs.WrapperGS;
		this.lFundAdr = ctrls.get('lFundAdr') as gs.WrapperGS;
		this.btnCopyAdrFund = ctrls.get('btnCopyAdrFund') as gs.WrapperGS;
		this.lAnchorAdr = ctrls.get('lAnchorAdr') as gs.WrapperGS;
		this.btnCopyAdrAnchor = ctrls.get('btnCopyAdrAnchor') as gs.WrapperGS;
		this.lManagerAdr = ctrls.get('lManagerAdr') as gs.WrapperGS;
		this.btnCopyAdrManager = ctrls.get('btnCopyAdrManager') as gs.WrapperGS;
		this.lPortfolio = ctrls.get('lPortfolio') as gs.WrapperGS;
		this.lYield = ctrls.get('lYield') as gs.WrapperGS;
		this.btnClaimYield = ctrls.get('btnClaimYield') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXDetailsBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXDetailsBaseControls;
	constructor (){
		super("cmpWidgetLPXDetails");
		this.ctrls = new CmpWidgetLPXDetailsBaseControls(this._controls);
	}
}
class CmpWidgetLPXHowWorkControls {
	public readonly blockStartLPX: gs.WrapperGS;
	public readonly cmpInfo3Steps: CmpInfo3Steps;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockStartLPX = ctrls.get('blockStartLPX') as gs.WrapperGS;
		this.cmpInfo3Steps = ctrls.get('cmpInfo3Steps') as CmpInfo3Steps;
	}
}
export class CmpWidgetLPXHowWork extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXHowWorkControls;
	constructor (){
		super("cmpWidgetLPXHowWork");
		this.ctrls = new CmpWidgetLPXHowWorkControls(this._controls);
	}
}
class CmpWidgetLPXNewDepControls {
	public readonly blockNewLPX: gs.WrapperGS;
	public readonly tglNewLPX: gs.WrapperGS;
	public readonly formNewLPX: gs.FormGS;
	public readonly cmpFundAdr: CmpInputAddress;
	public readonly cmpAnchorAdr: CmpInputAddress;
	public readonly cmpNtz: CmpInputIndex;
	public readonly cmpProfit: CmpInputIndex;
	public readonly btnNewLPX: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockNewLPX = ctrls.get('blockNewLPX') as gs.WrapperGS;
		this.tglNewLPX = ctrls.get('tglNewLPX') as gs.WrapperGS;
		this.formNewLPX = ctrls.get('formNewLPX') as gs.FormGS;
		this.cmpFundAdr = ctrls.get('cmpFundAdr') as CmpInputAddress;
		this.cmpAnchorAdr = ctrls.get('cmpAnchorAdr') as CmpInputAddress;
		this.cmpNtz = ctrls.get('cmpNtz') as CmpInputIndex;
		this.cmpProfit = ctrls.get('cmpProfit') as CmpInputIndex;
		this.btnNewLPX = ctrls.get('btnNewLPX') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXNewDep extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXNewDepControls;
	constructor (){
		super("cmpWidgetLPXNewDep");
		this.ctrls = new CmpWidgetLPXNewDepControls(this._controls);
	}
}
class CmpWidgetLPXStatusControls {
	public readonly lTotalStakePLS: gs.WrapperGS;
	public readonly lRate: gs.WrapperGS;
	public readonly lYourStakePLS: gs.WrapperGS;
	public readonly lYourStakeUPLS: gs.WrapperGS;
	public readonly lValidators: gs.WrapperGS;
	public readonly lValidatorsExiting: gs.WrapperGS;
	public readonly lTotalStakeUPLS: gs.WrapperGS;
	public readonly lInstWithdrawal: gs.WrapperGS;
	public readonly lTotalWithdrawal: gs.WrapperGS;
	public readonly lVXAddress: gs.WrapperGS;
	public readonly lVPoolAddress: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.lTotalStakePLS = ctrls.get('lTotalStakePLS') as gs.WrapperGS;
		this.lRate = ctrls.get('lRate') as gs.WrapperGS;
		this.lYourStakePLS = ctrls.get('lYourStakePLS') as gs.WrapperGS;
		this.lYourStakeUPLS = ctrls.get('lYourStakeUPLS') as gs.WrapperGS;
		this.lValidators = ctrls.get('lValidators') as gs.WrapperGS;
		this.lValidatorsExiting = ctrls.get('lValidatorsExiting') as gs.WrapperGS;
		this.lTotalStakeUPLS = ctrls.get('lTotalStakeUPLS') as gs.WrapperGS;
		this.lInstWithdrawal = ctrls.get('lInstWithdrawal') as gs.WrapperGS;
		this.lTotalWithdrawal = ctrls.get('lTotalWithdrawal') as gs.WrapperGS;
		this.lVXAddress = ctrls.get('lVXAddress') as gs.WrapperGS;
		this.lVPoolAddress = ctrls.get('lVPoolAddress') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXStatus extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXStatusControls;
	constructor (){
		super("cmpWidgetLPXStatus");
		this.ctrls = new CmpWidgetLPXStatusControls(this._controls);
	}
}
class CmpWidgetLPXTableBaseControls {
	public readonly btnTabStake: gs.WrapperGS;
	public readonly btnTabUnstake: gs.WrapperGS;
	public readonly list: gs.WrapperGS;
	public readonly cmpSearch: CmpSearch;
	public readonly btnFilterPortfolio: gs.BoxItem;
	public readonly btnFilterManager: gs.BoxItem;
	public readonly btnFilterSolo: gs.BoxItem;
	public readonly tableBottom: gs.WrapperGS;
	public readonly pagination: gs.WrapperGS;
	public readonly btnPagePrev: gs.WrapperGS;
	public readonly lPage: gs.WrapperGS;
	public readonly btnPageNext: gs.WrapperGS;
	public readonly blockNewLPX: gs.WrapperGS;
	public readonly btnNewLPX: gs.WrapperGS;
	public readonly blockConnect: gs.WrapperGS;
	public readonly btnConnect: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.btnTabStake = ctrls.get('btnTabStake') as gs.WrapperGS;
		this.btnTabUnstake = ctrls.get('btnTabUnstake') as gs.WrapperGS;
		this.list = ctrls.get('list') as gs.WrapperGS;
		this.cmpSearch = ctrls.get('cmpSearch') as CmpSearch;
		this.btnFilterPortfolio = ctrls.get('btnFilterPortfolio') as gs.BoxItem;
		this.btnFilterManager = ctrls.get('btnFilterManager') as gs.BoxItem;
		this.btnFilterSolo = ctrls.get('btnFilterSolo') as gs.BoxItem;
		this.tableBottom = ctrls.get('tableBottom') as gs.WrapperGS;
		this.pagination = ctrls.get('pagination') as gs.WrapperGS;
		this.btnPagePrev = ctrls.get('btnPagePrev') as gs.WrapperGS;
		this.lPage = ctrls.get('lPage') as gs.WrapperGS;
		this.btnPageNext = ctrls.get('btnPageNext') as gs.WrapperGS;
		this.blockNewLPX = ctrls.get('blockNewLPX') as gs.WrapperGS;
		this.btnNewLPX = ctrls.get('btnNewLPX') as gs.WrapperGS;
		this.blockConnect = ctrls.get('blockConnect') as gs.WrapperGS;
		this.btnConnect = ctrls.get('btnConnect') as gs.WrapperGS;
	}
}
export class CmpWidgetLPXTableBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetLPXTableBaseControls;
	constructor (){
		super("cmpWidgetLPXTable");
		this.ctrls = new CmpWidgetLPXTableBaseControls(this._controls);
	}
}
class CmpWidgetShareXSavedBaseControls {
	public readonly list: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.list = ctrls.get('list') as gs.WrapperGS;
	}
}
export class CmpWidgetShareXSavedBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetShareXSavedBaseControls;
	constructor (){
		super("cmpWidgetShareXSaved");
		this.ctrls = new CmpWidgetShareXSavedBaseControls(this._controls);
	}
}
class CmpWidgetShareXTableBaseControls {
	public readonly cmpSearch: CmpSearch;
	public readonly btnSelect: gs.WrapperGS;
	public readonly blockList: gs.WrapperGS;
	public readonly btnAll: gs.WrapperGS;
	public readonly list: gs.WrapperGS;
	public readonly btns: gs.WrapperGS;
	public readonly btnCalc: gs.WrapperGS;
	public readonly btnClaim: gs.WrapperGS;
	public readonly blockConnect: gs.WrapperGS;
	public readonly btnConnect: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpSearch = ctrls.get('cmpSearch') as CmpSearch;
		this.btnSelect = ctrls.get('btnSelect') as gs.WrapperGS;
		this.blockList = ctrls.get('blockList') as gs.WrapperGS;
		this.btnAll = ctrls.get('btnAll') as gs.WrapperGS;
		this.list = ctrls.get('list') as gs.WrapperGS;
		this.btns = ctrls.get('btns') as gs.WrapperGS;
		this.btnCalc = ctrls.get('btnCalc') as gs.WrapperGS;
		this.btnClaim = ctrls.get('btnClaim') as gs.WrapperGS;
		this.blockConnect = ctrls.get('blockConnect') as gs.WrapperGS;
		this.btnConnect = ctrls.get('btnConnect') as gs.WrapperGS;
	}
}
export class CmpWidgetShareXTableBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetShareXTableBaseControls;
	constructor (){
		super("cmpWidgetShareXTable");
		this.ctrls = new CmpWidgetShareXTableBaseControls(this._controls);
	}
}
class CmpWidgetShareXTokensBaseControls {
	public readonly cmpSearch: CmpSearch;
	public readonly btnAdd: gs.WrapperGS;
	public readonly list: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpSearch = ctrls.get('cmpSearch') as CmpSearch;
		this.btnAdd = ctrls.get('btnAdd') as gs.WrapperGS;
		this.list = ctrls.get('list') as gs.WrapperGS;
	}
}
export class CmpWidgetShareXTokensBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetShareXTokensBaseControls;
	constructor (){
		super("cmpWidgetShareXTokens");
		this.ctrls = new CmpWidgetShareXTokensBaseControls(this._controls);
	}
}
class CmpWidgetVXAppBaseControls {
	public readonly blockBtnsClaim: gs.WrapperGS;
	public readonly btnClaimUPLS: CmpBtnWithTag;
	public readonly btnClaimPLS: CmpBtnWithTag;
	public readonly btnTabStake: gs.WrapperGS;
	public readonly btnTabUnstake: gs.WrapperGS;
	public readonly tabStake: gs.WrapperGS;
	public readonly rStakeRangePLS: CmpRange;
	public readonly cmpStakeTokens: CmpInputTokensSwap;
	public readonly lValidatorsGas: gs.WrapperGS;
	public readonly aAddUPLSToWallet1: gs.WrapperGS;
	public readonly btnStake: gs.WrapperGS;
	public readonly btnConnect: gs.WrapperGS;
	public readonly tabUnstake: gs.WrapperGS;
	public readonly cmpUnstakeTokens: CmpInputTokensSwap;
	public readonly aAddUPLSToWallet2: gs.WrapperGS;
	public readonly btnUnstake: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockBtnsClaim = ctrls.get('blockBtnsClaim') as gs.WrapperGS;
		this.btnClaimUPLS = ctrls.get('btnClaimUPLS') as CmpBtnWithTag;
		this.btnClaimPLS = ctrls.get('btnClaimPLS') as CmpBtnWithTag;
		this.btnTabStake = ctrls.get('btnTabStake') as gs.WrapperGS;
		this.btnTabUnstake = ctrls.get('btnTabUnstake') as gs.WrapperGS;
		this.tabStake = ctrls.get('tabStake') as gs.WrapperGS;
		this.rStakeRangePLS = ctrls.get('rStakeRangePLS') as CmpRange;
		this.cmpStakeTokens = ctrls.get('cmpStakeTokens') as CmpInputTokensSwap;
		this.lValidatorsGas = ctrls.get('lValidatorsGas') as gs.WrapperGS;
		this.aAddUPLSToWallet1 = ctrls.get('aAddUPLSToWallet1') as gs.WrapperGS;
		this.btnStake = ctrls.get('btnStake') as gs.WrapperGS;
		this.btnConnect = ctrls.get('btnConnect') as gs.WrapperGS;
		this.tabUnstake = ctrls.get('tabUnstake') as gs.WrapperGS;
		this.cmpUnstakeTokens = ctrls.get('cmpUnstakeTokens') as CmpInputTokensSwap;
		this.aAddUPLSToWallet2 = ctrls.get('aAddUPLSToWallet2') as gs.WrapperGS;
		this.btnUnstake = ctrls.get('btnUnstake') as gs.WrapperGS;
	}
}
export class CmpWidgetVXAppBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetVXAppBaseControls;
	constructor (){
		super("cmpWidgetVXApp");
		this.ctrls = new CmpWidgetVXAppBaseControls(this._controls);
	}
}
class CmpWidgetVXSAppBaseControls {
	public readonly btnTabStrategy: gs.BoxItem;
	public readonly btnTabExecutor: gs.BoxItem;
	public readonly btnTabVX: gs.WrapperGS;
	public readonly tabStrategy: gs.WrapperGS;
	public readonly blockConnect: gs.WrapperGS;
	public readonly btnConnect: gs.WrapperGS;
	public readonly lHowWork: gs.WrapperGS;
	public readonly formConfig: gs.FormGS;
	public readonly iVXSConfig_uPLSInStake: gs.InputGS;
	public readonly iVXSConfig_SendPLSIndex: gs.InputGS;
	public readonly iVXSConfig_SendPLSReceiver: gs.InputGS;
	public readonly iVXSConfig_BnSIndex: gs.InputGS;
	public readonly rbSwapRouter: gs.RadioBox;
	public readonly blockSwapPath: gs.WrapperGS;
	public readonly cmpSwapPath0: CmpFormItemAddressPath;
	public readonly iVXSConfig_SwapMinPLSAmount: gs.InputGS;
	public readonly iVXSConfig_SwapMaxPLSAmount: gs.InputGS;
	public readonly cbUseBurn: gs.CheckBox;
	public readonly blockBnSAddress: gs.WrapperGS;
	public readonly iVXSSConfig_SendAddress: gs.InputGS;
	public readonly lVXSConfigStats: gs.WrapperGS;
	public readonly lVXSConfigStrategyAddress: gs.WrapperGS;
	public readonly lVXSConfigStrategyUPLS: gs.WrapperGS;
	public readonly btnSubmitStrategy: gs.WrapperGS;
	public readonly tabExecutor: gs.WrapperGS;
	public readonly formExecutor: gs.FormGS;
	public readonly iVXSBot_SwapFrequencyHours: gs.InputGS;
	public readonly iVXSBot_SplitFrequencyHours: gs.InputGS;
	public readonly iVXSBot_SplitMinProfitAmount: gs.InputGS;
	public readonly iVXSBot_MaxGasAmount: gs.InputGS;
	public readonly btnSubmitExecutor: gs.WrapperGS;
	public readonly blockDeposit: gs.WrapperGS;
	public readonly formDeposit: gs.FormGS;
	public readonly iVXSConfig_DepositUPLS: gs.InputGS;
	public readonly btnDepositUPLS: gs.WrapperGS;
	public readonly blockWithdraw: gs.WrapperGS;
	public readonly formWithdraw: gs.FormGS;
	public readonly btnWithdrawUPLS: gs.WrapperGS;
	public readonly btnWithdrawPLS: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.btnTabStrategy = ctrls.get('btnTabStrategy') as gs.BoxItem;
		this.btnTabExecutor = ctrls.get('btnTabExecutor') as gs.BoxItem;
		this.btnTabVX = ctrls.get('btnTabVX') as gs.WrapperGS;
		this.tabStrategy = ctrls.get('tabStrategy') as gs.WrapperGS;
		this.blockConnect = ctrls.get('blockConnect') as gs.WrapperGS;
		this.btnConnect = ctrls.get('btnConnect') as gs.WrapperGS;
		this.lHowWork = ctrls.get('lHowWork') as gs.WrapperGS;
		this.formConfig = ctrls.get('formConfig') as gs.FormGS;
		this.iVXSConfig_uPLSInStake = ctrls.get('iVXSConfig_uPLSInStake') as gs.InputGS;
		this.iVXSConfig_SendPLSIndex = ctrls.get('iVXSConfig_SendPLSIndex') as gs.InputGS;
		this.iVXSConfig_SendPLSReceiver = ctrls.get('iVXSConfig_SendPLSReceiver') as gs.InputGS;
		this.iVXSConfig_BnSIndex = ctrls.get('iVXSConfig_BnSIndex') as gs.InputGS;
		this.rbSwapRouter = ctrls.get('rbSwapRouter') as gs.RadioBox;
		this.blockSwapPath = ctrls.get('blockSwapPath') as gs.WrapperGS;
		this.cmpSwapPath0 = ctrls.get('cmpSwapPath0') as CmpFormItemAddressPath;
		this.iVXSConfig_SwapMinPLSAmount = ctrls.get('iVXSConfig_SwapMinPLSAmount') as gs.InputGS;
		this.iVXSConfig_SwapMaxPLSAmount = ctrls.get('iVXSConfig_SwapMaxPLSAmount') as gs.InputGS;
		this.cbUseBurn = ctrls.get('cbUseBurn') as gs.CheckBox;
		this.blockBnSAddress = ctrls.get('blockBnSAddress') as gs.WrapperGS;
		this.iVXSSConfig_SendAddress = ctrls.get('iVXSSConfig_SendAddress') as gs.InputGS;
		this.lVXSConfigStats = ctrls.get('lVXSConfigStats') as gs.WrapperGS;
		this.lVXSConfigStrategyAddress = ctrls.get('lVXSConfigStrategyAddress') as gs.WrapperGS;
		this.lVXSConfigStrategyUPLS = ctrls.get('lVXSConfigStrategyUPLS') as gs.WrapperGS;
		this.btnSubmitStrategy = ctrls.get('btnSubmitStrategy') as gs.WrapperGS;
		this.tabExecutor = ctrls.get('tabExecutor') as gs.WrapperGS;
		this.formExecutor = ctrls.get('formExecutor') as gs.FormGS;
		this.iVXSBot_SwapFrequencyHours = ctrls.get('iVXSBot_SwapFrequencyHours') as gs.InputGS;
		this.iVXSBot_SplitFrequencyHours = ctrls.get('iVXSBot_SplitFrequencyHours') as gs.InputGS;
		this.iVXSBot_SplitMinProfitAmount = ctrls.get('iVXSBot_SplitMinProfitAmount') as gs.InputGS;
		this.iVXSBot_MaxGasAmount = ctrls.get('iVXSBot_MaxGasAmount') as gs.InputGS;
		this.btnSubmitExecutor = ctrls.get('btnSubmitExecutor') as gs.WrapperGS;
		this.blockDeposit = ctrls.get('blockDeposit') as gs.WrapperGS;
		this.formDeposit = ctrls.get('formDeposit') as gs.FormGS;
		this.iVXSConfig_DepositUPLS = ctrls.get('iVXSConfig_DepositUPLS') as gs.InputGS;
		this.btnDepositUPLS = ctrls.get('btnDepositUPLS') as gs.WrapperGS;
		this.blockWithdraw = ctrls.get('blockWithdraw') as gs.WrapperGS;
		this.formWithdraw = ctrls.get('formWithdraw') as gs.FormGS;
		this.btnWithdrawUPLS = ctrls.get('btnWithdrawUPLS') as gs.WrapperGS;
		this.btnWithdrawPLS = ctrls.get('btnWithdrawPLS') as gs.WrapperGS;
	}
}
export class CmpWidgetVXSAppBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetVXSAppBaseControls;
	constructor (){
		super("cmpWidgetVXSApp");
		this.ctrls = new CmpWidgetVXSAppBaseControls(this._controls);
	}
}
class CmpWidgetVXStatusBaseControls {
	public readonly lTotalStakePLS: gs.WrapperGS;
	public readonly lRate: gs.WrapperGS;
	public readonly lYourStakePLS: gs.WrapperGS;
	public readonly lYourStakeUPLS: gs.WrapperGS;
	public readonly lValidators: gs.WrapperGS;
	public readonly lValidatorsExiting: gs.WrapperGS;
	public readonly lTotalStakeUPLS: gs.WrapperGS;
	public readonly lInstWithdrawal: gs.WrapperGS;
	public readonly lTotalWithdrawal: gs.WrapperGS;
	public readonly lVXAddress: gs.WrapperGS;
	public readonly lVPoolAddress: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.lTotalStakePLS = ctrls.get('lTotalStakePLS') as gs.WrapperGS;
		this.lRate = ctrls.get('lRate') as gs.WrapperGS;
		this.lYourStakePLS = ctrls.get('lYourStakePLS') as gs.WrapperGS;
		this.lYourStakeUPLS = ctrls.get('lYourStakeUPLS') as gs.WrapperGS;
		this.lValidators = ctrls.get('lValidators') as gs.WrapperGS;
		this.lValidatorsExiting = ctrls.get('lValidatorsExiting') as gs.WrapperGS;
		this.lTotalStakeUPLS = ctrls.get('lTotalStakeUPLS') as gs.WrapperGS;
		this.lInstWithdrawal = ctrls.get('lInstWithdrawal') as gs.WrapperGS;
		this.lTotalWithdrawal = ctrls.get('lTotalWithdrawal') as gs.WrapperGS;
		this.lVXAddress = ctrls.get('lVXAddress') as gs.WrapperGS;
		this.lVPoolAddress = ctrls.get('lVPoolAddress') as gs.WrapperGS;
	}
}
export class CmpWidgetVXStatusBase extends gs.WrapperGS {
	public readonly ctrls: CmpWidgetVXStatusBaseControls;
	constructor (){
		super("cmpWidgetVXStatus");
		this.ctrls = new CmpWidgetVXStatusBaseControls(this._controls);
	}
}
class LayoutMainControls {
	public readonly cmpHeader: CmpHeader;
	public readonly cmpTxLock: gs.WrapperGS;
	public readonly lTxLock: gs.WrapperGS;
	public readonly pageContainer: gs.WrapperGS;
	public readonly footer: gs.WrapperGS;
	public readonly lVersion: gs.WrapperGS;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpHeader = ctrls.get('cmpHeader') as CmpHeader;
		this.cmpTxLock = ctrls.get('cmpTxLock') as gs.WrapperGS;
		this.lTxLock = ctrls.get('lTxLock') as gs.WrapperGS;
		this.pageContainer = ctrls.get('pageContainer') as gs.WrapperGS;
		this.footer = ctrls.get('footer') as gs.WrapperGS;
		this.lVersion = ctrls.get('lVersion') as gs.WrapperGS;
	}
}
export class LayoutMain extends gs.WrapperGS {
	public readonly ctrls: LayoutMainControls;
	constructor (){
		super("layoutMain");
		this.ctrls = new LayoutMainControls(this._controls);
	}
}
class PageLoadingLPXControls {
	public readonly cmpHeroLPX: CmpHeroLPX;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpHeroLPX = ctrls.get('cmpHeroLPX') as CmpHeroLPX;
	}
}
export class PageLoadingLPX extends gs.WrapperGS {
	public readonly ctrls: PageLoadingLPXControls;
	constructor (){
		super("pageLoadingLPX");
		this.ctrls = new PageLoadingLPXControls(this._controls);
	}
}
class PageLoadingShareXControls {
	public readonly cmpHeroShareX: CmpHeroShareX;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpHeroShareX = ctrls.get('cmpHeroShareX') as CmpHeroShareX;
	}
}
export class PageLoadingShareX extends gs.WrapperGS {
	public readonly ctrls: PageLoadingShareXControls;
	constructor (){
		super("pageLoadingShareX");
		this.ctrls = new PageLoadingShareXControls(this._controls);
	}
}
class PageLoadingVXControls {
	public readonly cmpHeroVX: CmpHeroVX;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpHeroVX = ctrls.get('cmpHeroVX') as CmpHeroVX;
	}
}
export class PageLoadingVX extends gs.WrapperGS {
	public readonly ctrls: PageLoadingVXControls;
	constructor (){
		super("pageLoadingVX");
		this.ctrls = new PageLoadingVXControls(this._controls);
	}
}
class PageLPXControls {
	public readonly cmpHero: CmpHeroLPX;
	public readonly blockNewLPX: gs.WrapperGS;
	public readonly cmpWgtLPXNew: CmpWgtLPXNew;
	public readonly blockMain: gs.WrapperGS;
	public readonly cmpWidgetLPXTable: CmpWidgetLPXTable;
	public readonly cmpWidgetLPXCtrl: CmpWidgetLPXCtrl;
	public readonly cmpWidgetLPXHowWork: CmpWidgetLPXHowWork;
	public readonly cmpWidgetLPXDetails: CmpWidgetLPXDetails;
	public readonly cmpChart: CmpWidgetChart;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpHero = ctrls.get('cmpHero') as CmpHeroLPX;
		this.blockNewLPX = ctrls.get('blockNewLPX') as gs.WrapperGS;
		this.cmpWgtLPXNew = ctrls.get('cmpWgtLPXNew') as CmpWgtLPXNew;
		this.blockMain = ctrls.get('blockMain') as gs.WrapperGS;
		this.cmpWidgetLPXTable = ctrls.get('cmpWidgetLPXTable') as CmpWidgetLPXTable;
		this.cmpWidgetLPXCtrl = ctrls.get('cmpWidgetLPXCtrl') as CmpWidgetLPXCtrl;
		this.cmpWidgetLPXHowWork = ctrls.get('cmpWidgetLPXHowWork') as CmpWidgetLPXHowWork;
		this.cmpWidgetLPXDetails = ctrls.get('cmpWidgetLPXDetails') as CmpWidgetLPXDetails;
		this.cmpChart = ctrls.get('cmpChart') as CmpWidgetChart;
	}
}
export class PageLPX extends gs.WrapperGS {
	public readonly ctrls: PageLPXControls;
	constructor (){
		super("pageLPX");
		this.ctrls = new PageLPXControls(this._controls);
	}
}
class PageShareXControls {
	public readonly blockLeft: gs.WrapperGS;
	public readonly cmpSharexSaved: CmpWidgetShareXSaved;
	public readonly blockCenter: gs.WrapperGS;
	public readonly cmpWidgetShareXTable: CmpWidgetShareXTable;
	public readonly blockRight: gs.WrapperGS;
	public readonly cmpTokens: CmpWidgetShareXTokens;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.blockLeft = ctrls.get('blockLeft') as gs.WrapperGS;
		this.cmpSharexSaved = ctrls.get('cmpSharexSaved') as CmpWidgetShareXSaved;
		this.blockCenter = ctrls.get('blockCenter') as gs.WrapperGS;
		this.cmpWidgetShareXTable = ctrls.get('cmpWidgetShareXTable') as CmpWidgetShareXTable;
		this.blockRight = ctrls.get('blockRight') as gs.WrapperGS;
		this.cmpTokens = ctrls.get('cmpTokens') as CmpWidgetShareXTokens;
	}
}
export class PageShareX extends gs.WrapperGS {
	public readonly ctrls: PageShareXControls;
	constructor (){
		super("pageShareX");
		this.ctrls = new PageShareXControls(this._controls);
	}
}
class PageVXControls {
	public readonly cmpHeroVX: CmpHeroVX;
	public readonly blockLeft: gs.WrapperGS;
	public readonly widgetInfoVXS: CmpWidgetInfoVXS;
	public readonly widgetInfoVX: CmpWidgetInfoVX;
	public readonly widgetInfoLPX: CmpWidgetInfoLPX;
	public readonly blockCenter: gs.WrapperGS;
	public readonly widgetVXApp: CmpWidgetVXApp;
	public readonly widgetVXSApp: CmpWidgetVXSApp;
	public readonly blockRight: gs.WrapperGS;
	public readonly widgetVXStatus: CmpWidgetVXStatus;
	public readonly widgetInfoSV: CmpWidgetInfoSV;
	public readonly widgetChart: CmpWidgetChart;
	constructor (ctrls: Map<string, gs.WrapperGS>){
		this.cmpHeroVX = ctrls.get('cmpHeroVX') as CmpHeroVX;
		this.blockLeft = ctrls.get('blockLeft') as gs.WrapperGS;
		this.widgetInfoVXS = ctrls.get('widgetInfoVXS') as CmpWidgetInfoVXS;
		this.widgetInfoVX = ctrls.get('widgetInfoVX') as CmpWidgetInfoVX;
		this.widgetInfoLPX = ctrls.get('widgetInfoLPX') as CmpWidgetInfoLPX;
		this.blockCenter = ctrls.get('blockCenter') as gs.WrapperGS;
		this.widgetVXApp = ctrls.get('widgetVXApp') as CmpWidgetVXApp;
		this.widgetVXSApp = ctrls.get('widgetVXSApp') as CmpWidgetVXSApp;
		this.blockRight = ctrls.get('blockRight') as gs.WrapperGS;
		this.widgetVXStatus = ctrls.get('widgetVXStatus') as CmpWidgetVXStatus;
		this.widgetInfoSV = ctrls.get('widgetInfoSV') as CmpWidgetInfoSV;
		this.widgetChart = ctrls.get('widgetChart') as CmpWidgetChart;
	}
}
export class PageVX extends gs.WrapperGS {
	public readonly ctrls: PageVXControls;
	constructor (){
		super("pageVX");
		this.ctrls = new PageVXControls(this._controls);
	}
}
